import { Main } from "./presentation/Main";
import "./assets/css/_global.scss";
import { QueryClient, QueryClientProvider } from "react-query";
import { AuthProvider } from "./hooks/useAuth";
import { TranslationProvider } from "./hooks/useTranslation";
import { SnackbarProvider } from "./hooks/useSnackbar";
import { LoadingProvider } from "./hooks/useLoading";

const queryClient = new QueryClient();

function App() {
  return (
    <AuthProvider>
      <TranslationProvider>
        <SnackbarProvider>
          <LoadingProvider>
            <QueryClientProvider client={queryClient}>
              <Main />
            </QueryClientProvider>
          </LoadingProvider>
        </SnackbarProvider>
      </TranslationProvider>
    </AuthProvider>
  );
}

export default App;
